import { Button } from "antd";
import { memo } from "react";
import styled from "styled-components";

interface Props {
  onOpen: () => void;
}

const DrawerButton = styled(Button)`
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 1000;
  pointer-events: auto;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 34px !important;
  height: 34px;
  padding: 0;

  background: #393e46 !important;
  color: #eeeeee !important;
  border: 1px solid #8e1616 !important;
  border-radius: 8px;

  &:hover {
    background: #222831 !important;
    border-color: #8e1616 !important;
    box-shadow: 0 0 0 2px rgba(142, 22, 22, 0.2);
  }
`;

const LogoImg = styled.img`
  height: 22px;
  width: 22px;
  display: block;
`;

function ControlsDrawerButton({ onOpen }: Props) {
  return (
    <DrawerButton
      aria-label="Open controls"
      onClick={onOpen}
      type="default"
      icon={<LogoImg src="/logo.png" alt="Open controls" />}
    />
  );
}

export default memo(ControlsDrawerButton);
